module.exports = __webpack_public_path__ + "img/example5.e8bd8db5.jpg";